import * as tslib_1 from "tslib";
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var QuizService = /** @class */ (function () {
    function QuizService(http) {
        this.http = http;
    }
    QuizService.prototype.list = function (filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http
                        .get(environment.apiUrl + "/cms/quizzes" + (filter || ''))
                        .toPromise()];
            });
        });
    };
    QuizService.prototype.listCustomers = function (id, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http
                        .get(environment.apiUrl + "/cms/customers/" + id + "/quizzes" + (filter || ''))
                        .toPromise()];
            });
        });
    };
    QuizService.prototype.listanswersAndQuestions = function (id, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http
                        .get(environment.apiUrl + "/cms/quizzes/" + id + "/answers/" + (filter || ''))
                        .toPromise()];
            });
        });
    };
    QuizService.prototype.listQuizClient = function (id, filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http
                        .get(environment.apiUrl + "/cms/quizzes/" + id + "/customers" + (filter || ''))
                        .toPromise()];
            });
        });
    };
    QuizService.prototype.findOne = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(environment.apiUrl + "/cms/quizzes/" + id).toPromise()];
            });
        });
    };
    QuizService.prototype.create = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, formData, key;
            return tslib_1.__generator(this, function (_a) {
                headers = {
                    'Content-Type': 'multipart/form-data',
                };
                formData = new FormData();
                for (key in data) {
                    if (!Object.prototype.hasOwnProperty.call(data, key)) {
                        continue;
                    }
                    formData.append(key, data[key]);
                }
                return [2 /*return*/, this.http
                        .post(environment.apiUrl + "/cms/quizzes", formData, { headers: headers })
                        .toPromise()];
            });
        });
    };
    QuizService.prototype.update = function (id, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, formData, key;
            return tslib_1.__generator(this, function (_a) {
                headers = {
                    'Content-Type': 'multipart/form-data',
                };
                formData = new FormData();
                for (key in data) {
                    if (!Object.prototype.hasOwnProperty.call(data, key)) {
                        continue;
                    }
                    formData.append(key, data[key]);
                }
                return [2 /*return*/, this.http
                        .put(environment.apiUrl + "/cms/quizzes/" + id, formData, { headers: headers })
                        .toPromise()];
            });
        });
    };
    QuizService.prototype.delete = function (quizID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.delete(environment.apiUrl + "/cms/quizzes/" + quizID).toPromise()];
            });
        });
    };
    QuizService.prototype.getS3Url = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(environment.apiUrl + "/cms/events/s3-slot").toPromise()];
            });
        });
    };
    QuizService.prototype.uploadToS3 = function (pathAwsUpload, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put("" + pathAwsUpload, data).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuizService.prototype.createTrigger = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.post(environment.apiUrl + "/cms/trigger", data).toPromise()];
            });
        });
    };
    QuizService.prototype.getTrigger = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(environment.apiUrl + "/cms/trigger").toPromise()];
            });
        });
    };
    QuizService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuizService_Factory() { return new QuizService(i0.ɵɵinject(i1.HttpClient)); }, token: QuizService, providedIn: "root" });
    return QuizService;
}());
export { QuizService };
